import styled from 'styled-components';

const Grid = styled.div`
  position: relative;
  overflow-y: initial;
  margin: 0 20%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;

  ${Styles.mobile`
    margin: 0;
  `}
`;

export default Grid;
